export const CREATE_INVITE_LINK_REQUEST = 'CREATE_INVITE_LINK_REQUEST';
export const CREATE_INVITE_LINK_SUCCESS = 'CREATE_INVITE_LINK_SUCCESS';
export const CREATE_INVITE_LINK_FAILED = 'CREATE_INVITE_LINK_FAILED';
export const CLEAR_LINK = 'CLEAR_LINK';

export const GET_DATA_FOR_INVITE_FORM_REQUEST = 'GET_DATA_FOR_INVITE_FORM_REQUEST';
export const GET_DATA_FOR_INVITE_FORM_SUCCESS = 'GET_DATA_FOR_INVITE_FORM_SUCCESS';
export const GET_DATA_FOR_INVITE_FORM_FAILED = 'GET_DATA_FOR_INVITE_FORM_FAILED';
